const SET_CAMPAIGNS_BUDGETS = "SET_CAMPAIGNS_BUDGETS";
const ADD_CAMPAIGN_BUDGET = "ADD_CAMPAIGN_BUDGET";
const UPDATE_CAMPAIGN_BUDGET = "UPDATE_CAMPAIGN_BUDGET";
const REMOVE_CAMPAIGN_BUDGET = "REMOVE_CAMPAIGN_BUDGET";
const SET_CAMPAIGN_BUDGET_DOWNLOADS = "SET_CAMPAIGN_BUDGET_DOWNLOADS";
const ADD_CAMPAIGN_BUDGET_DOWNLOAD = "ADD_CAMPAIGN_BUDGET_DOWNLOAD";
const UPDATE_CAMPAIGN_BUDGET_DOWNLOAD = "UPDATE_CAMPAIGN_BUDGET_DOWNLOAD";
const REMOVE_CAMPAIGN_BUDGET_DOWNLOAD = "REMOVE_CAMPAIGN_BUDGET_DOWNLOAD";

export {
  SET_CAMPAIGNS_BUDGETS,
  ADD_CAMPAIGN_BUDGET,
  UPDATE_CAMPAIGN_BUDGET,
  REMOVE_CAMPAIGN_BUDGET,
  SET_CAMPAIGN_BUDGET_DOWNLOADS,
  ADD_CAMPAIGN_BUDGET_DOWNLOAD,
  UPDATE_CAMPAIGN_BUDGET_DOWNLOAD,
  REMOVE_CAMPAIGN_BUDGET_DOWNLOAD,
};
